<template>
    <div class="download_page">
        <div class="download_page_div">
            <div class="info_div">

                <div class="welcome_text">
                    {{label["downloadpage_welcome_text"]}}
                </div>
                <div class="main_text">
                    {{label["downloadpage_main_text"]}}
                </div>
                <div class="sub_text">
                    {{label["downloadpage_sub_text"]}}
                </div>
                <div class="download_icon_div">
                    <div class="left_div">
                        <a :href="info.iphone_download_url" target="_blank">
                            <img src="/files/images/download_page/img_app_store.png" />
                        </a>
                    </div>
                    <div class="right_div">
                        <a :href="info.android_download_url" target="_blank">
                            <img src="/files/images/download_page/img_play_store.png" />
                        </a>
                    </div>
                </div>


            </div>
            <div class="phone_div">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                currentOS: ""
            };
        },
        computed: {
            info() {
                return this.$root.info;
            },
            label() {
                return this.$root.getLabel();
            }
        },
        components: {},
        created() {
            this.currentOS = GetBrowserVersion().os;
            console.log('this.currentOS', this.currentOS);

            this.$root.showHeader = false;
            this.$root.showFooter = false;

            this.info.loading = false;
            this.$root.getCurrentPathName();

            if (this.info.currentPathName == "/download") {
                this.redirectToDownloadPage();
            }
            else if (this.info.currentPathName == "/shoporder") {
                if (this.currentOS != "ios" && this.currentOS != "android") {
                    this.openAppShopOrder('web'); 
                }
                else {
                    this.openAppShopOrder();
                }
            }
            else if (this.info.currentPathName == "/eshop") {
                if (this.currentOS != "ios" && this.currentOS != "android") {
                    this.openEShopPage('web');
                }
                else {
                    this.openEShopPage();
                }
            }
			else if (this.info.currentPathName == "/orderConfrim") {
				this.openOrderConfirm();
			}
        },
        methods: {
            redirectToDownloadPage() {
                var app = this;
                if (app.currentOS == "ios") {
                    window.location.replace(app.info.iphone_download_url);
                } else if (app.currentOS == "android") {
                    window.location.replace(app.info.android_download_url);
                }
            },
            openAppShopOrder(t) {
                var app = this;
                var shopCode = this.$root.getParameterByName("shop");

                if (shopCode != null && shopCode != "") {
                    if (t == "web") {
                        window.location.replace("/?order_mode=order&default_shopcode=" + encodeURI(shopCode));
                    }
                    else {
                        try {
                            var path = this.info.app_open_url + "?action=olo&order_mode=order&default_shopcode=" + encodeURI(shopCode);
                            //alert(path);
                            window.location = path;
                            //window.open(path);
                        }
                        catch (e) {
                            //alert(e);
                            console.log(e);
                        }

                        // redirect to download page when cannot open app
                        window.setTimeout(function () {
                            app.redirectToDownloadPage();
                        }, 5000);
                    }
                }
            },
            openEShopPage(t) {
                var app = this;

                if (t == "web") {
                    window.location.replace("/?order_mode=shopping");
                }
                else {
                    try {
                        var path = this.info.app_open_url + "?action=olo&order_mode=shopping";
                        //alert(path);
                        window.location = path;
                        //window.open(path);
                    }
                    catch (e) {
                        //alert(e);
                        console.log(e);
                    }

                    // redirect to download page when cannot open app
                    window.setTimeout(function () {
                        app.redirectToDownloadPage();
                    }, 5000);
                }
            },
			openOrderConfirm() {
                var orderNo = this.$root.getParameterByName("orderNo");
                var isCancel = this.$root.getParameterByName("isCancel");
				if (isCancel == null || isCancel == "") {
					isCancel = "0";
				}

                if (orderNo != null && orderNo != "") {
                    try {
                        var path = this.info.app_open_url + "?action=orderConfirmation&orderNo="+encodeURI(orderNo)+"&isCancel=" + isCancel;
                        //alert(path);
                        window.location.href = path;
                        //window.open(path);
                    }
                    catch (e) {
                        //alert(e);
                        console.log(e);
                    }
                }
            }
        }
    };
</script>
